import React, { useState, useEffect, useRef, useContext } from 'react';

const spinList = [
    {
        name: "promo",
        img: "/img/0.webp"
    },
    {
        name: "common",
        img: "/img/1.webp"
    },
    {
        name: "uncommon",
        img: "/img/2.webp"
    },
    {
        name: "rare",
        img: "/img/3.webp"
    },
    {
        name: "epic",
        img: "/img/4.webp"
    },
    {
        name: "legendary",
        img: "/img/5.webp"
    }
]

const runesList = [
    {
        name: "promo",
        img: "/img/runes/0.webp"
    },
    {
        name: "common",
        img: "/img/runes/1.webp"
    },
    {
        name: "uncommon",
        img: "/img/runes/2.webp"
    },
    {
        name: "rare",
        img: "/img/runes/3.webp"
    },
    {
        name: "epic",
        img: "/img/runes/4.webp"
    },
    {
        name: "legendary",
        img: "/img/runes/5.webp"
    }
]


function ModelResultComponent({ setModalResulOpen, spendSpn, getSpn, waxprice, allSlotPrice }) {

    const [number, setNumber] = useState(1);

    const handleChange = (event) => {
        setNumber(event.target.value);
    };

    return (
        <div className="modal choose-spin-runes">
            <div className="modal-in">
                <div className="modal-body">
                    <div className="close-modal" onClick={() => setModalResulOpen(false)}></div>
                    <div className="modal-title">
                        detal information
                    </div>
                    <div className="detal-inform">
                        <div className="detal-info-tit">
                            information about spinneys
                        </div>
                        <table>
                            <tr>
                                <td>
                                    name
                                </td>
                                <td>
                                    spn
                                </td>
                                <td>
                                    wax
                                </td>
                            </tr>
                            <tr className='nen'>
                                <td>
                                    used SPN for spin:
                                </td>
                                <td>
                                    {spendSpn ? spendSpn.toFixed(4) : 0}
                                </td>
                                <td>
                                    {spendSpn ? (spendSpn * waxprice).toFixed(4) : 0}
                                </td>
                            </tr>
                            <tr className='green'>
                                <td>
                                    SPN net income from spins:
                                </td>
                                <td>
                                    {getSpn ? "+" + getSpn.toFixed(4) : 0}
                                </td>
                                <td>
                                    {getSpn ? "+" + (getSpn * waxprice).toFixed(4) : 0}
                                </td>
                            </tr>
                            <tr className=''>
                                <td>
                                    total income:
                                </td>
                                <td>
                                    {(spendSpn + getSpn).toFixed(4)}
                                </td>
                                <td>
                                    {((spendSpn + getSpn) * waxprice).toFixed(4)}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div className="detal-inform">
                        <div className="detal-info-tit">
                            default expenses
                        </div>
                        <table>
                            <tr>
                                <td>
                                    name
                                </td>
                                <td>
                                    spn
                                </td>
                                <td>
                                    wax
                                </td>
                            </tr>
                            <tr className='red'>
                                <td>
                                    buy slot:
                                </td>
                                <td>
                                    0
                                </td>
                                <td>
                                    -{allSlotPrice}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModelResultComponent;
